import { AWARD_CLASSIFICATION, QUALIFICATION_STATUS_TYPES } from '../constants';
import { DEGREE_LEVEL } from '../../../graphql';
import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../lang';

export const levelOfDegreeOptions: SelectOption[] = [
  {
    value: DEGREE_LEVEL.BACHELOR_DEGREE,
    label: "Bachelor's Degree",
  },
  {
    value: DEGREE_LEVEL.BACHELOR_DEGREE_MINOR,
    label: "Bachelor's Degree (Minor)",
  },
  {
    value: DEGREE_LEVEL.MASTER_DEGREE,
    label: "Master's Degree",
  },
  {
    value: DEGREE_LEVEL.DOCTORATE_DEGREE,
    label: "Doctorate's Degree",
  },
  {
    value: DEGREE_LEVEL.OTHERS,
    label: 'Others',
  },
];

export const initialCurrentStudyYearOptions: SelectOption[] = Array.from(
  { length: 10 },
  (_, year) => year,
).map((_, year) => ({
  value: year + 1,
  label: (year + 1).toString(),
}));

export const mediumOfInstructionOptions: SelectOption[] = [
  {
    value: 'CANTONESE',
    label: 'Cantonese',
  },
  {
    value: 'MANDARIN',
    label: 'Mandarin',
  },
  {
    value: 'ENGLISH',
    label: 'English',
  },
  {
    value: 'FRENCH',
    label: 'French',
  },
  {
    value: 'GERMAN',
    label: 'German',
  },
  {
    value: 'HINDI',
    label: 'Hindi',
  },
  {
    value: 'ITALIAN',
    label: 'Italian',
  },
  {
    value: 'JAPANESE',
    label: 'Japanese',
  },
  {
    value: 'KOREAN',
    label: 'Korean',
  },
  {
    value: 'MALAY',
    label: 'Malay',
  },
  {
    value: 'PORTUGUESE',
    label: 'Portuguese',
  },
  {
    value: 'RUSSIAN',
    label: 'Russian',
  },
  {
    value: 'SPANISH',
    label: 'Spanish',
  },
  {
    value: 'SWEDISH',
    label: 'Swedish',
  },
  {
    value: 'TAGALOG',
    label: 'Tagalog',
  },
  {
    value: 'THAI',
    label: 'Thai',
  },
  {
    value: 'TURKISH',
    label: 'Turkish',
  },
  {
    value: 'VIETNAMESE',
    label: 'Vietnamese',
  },
  {
    value: 'ARABIC',
    label: 'Arabic',
  },
  {
    value: 'DUTCH',
    label: 'Dutch',
  },
  {
    value: 'INDONESIAN',
    label: 'Indonesian',
  },
  {
    value: 'OTHERS',
    label: 'Others',
  },
  {
    value: 'NOT_APPLICABLE',
    label: 'Not Applicable',
  },
];

export const fieldOfStudyOptions: SelectOption[] = [
  {
    value: 'ACCOUNTING_AUDITING',
    label: 'Accounting / Auditing',
  },
  {
    value: 'ADMINISTRATION',
    label: 'Administration',
  },
  {
    value: 'ARCHITECTURE_BUILDING',
    label: 'Architecture / Building',
  },
  {
    value: 'BANKING_FINANCE',
    label: 'Banking / Finance',
  },
  {
    value: 'BIOMEDICAL_SCIENCE',
    label: 'Biomedical Science',
  },
  {
    value: 'BUSINESS',
    label: 'Business',
  },
  {
    value: 'CHINESE_MEDICINE',
    label: 'Chinese Medicine',
  },
  {
    value: 'CLOTHING_TEXTILE',
    label: 'Clothing and Textile',
  },
  {
    value: 'COMPUTING_IT',
    label: 'Computing / I.T.',
  },
  {
    value: 'DESIGN',
    label: 'Design',
  },
  {
    value: 'ENGINEERING',
    label: 'Engineering',
  },
  {
    value: 'HEALTH_CARE',
    label: 'Health Care',
  },
  {
    value: 'HOTEL_CATERING',
    label: 'Hotel / Catering',
  },
  {
    value: 'INSURANCE',
    label: 'Insurance',
  },
  {
    value: 'LANGUAGE',
    label: 'Language',
  },
  {
    value: 'LEGAL',
    label: 'Legal',
  },
  {
    value: 'LOGISTICS_TRANSPORT',
    label: 'Logistics & Transport',
  },
  {
    value: 'MANAGEMENT',
    label: 'Management',
  },
  {
    value: 'MARKETING',
    label: 'Marketing',
  },
  {
    value: 'MATHEMATICS',
    label: 'Mathematics',
  },
  {
    value: 'MEDICAL_LABORATORY',
    label: 'Medical Laboratory',
  },
  {
    value: 'NURSING',
    label: 'Nursing',
  },
  {
    value: 'OPTOMETRY',
    label: 'Optometry',
  },
  {
    value: 'REHABILITATION_SCIENCE',
    label: 'Rehabilitation Science',
  },
  {
    value: 'SCIENCE',
    label: 'Science',
  },
  {
    value: 'SOCIAL_WORK',
    label: 'Social Work',
  },
  {
    value: 'STATISTICS',
    label: 'Statistics',
  },
  {
    value: 'SURVEYING',
    label: 'Surveying',
  },
  {
    value: 'TEACHING',
    label: 'Teaching',
  },
  {
    value: 'OTHERS',
    label: 'Others',
  },
];

export const mediumOfQualificationOptions: SelectOption[] = [
  {
    value: 'COURSEWORK',
    label: 'Coursework',
  },
  {
    value: 'COURSEWORK_RESEARCH',
    label: 'Coursework & Research (with dissertation)',
  },
  {
    value: 'RESEARCH',
    label: 'Research (with dissertation)',
  },
];

export const initialQualificationStatusOptions: SelectOption[] = [
  {
    value: QUALIFICATION_STATUS_TYPES.GRADUATED,
    label: 'Graduated',
  },
  {
    value: QUALIFICATION_STATUS_TYPES.WILL_COMPLETE_STUDY_BEFORE,
    label: 'Will complete study before ',
  },
  {
    value: QUALIFICATION_STATUS_TYPES.WILL_GRADUATE_IN_AFTER,
    label: 'Will graduate in/after ',
  },
  {
    value: QUALIFICATION_STATUS_TYPES.COMPLETED_WITHOUT_AWARD,
    label: 'Completed without award',
  },
  {
    value: QUALIFICATION_STATUS_TYPES.WITHDRAW,
    label: 'Withdraw',
  },
];

export const awardClassificationOptions: SelectOption[] = [
  {
    value: AWARD_CLASSIFICATION.OTHERS,
    label: 'Not applicable / Others',
  },
  {
    value: AWARD_CLASSIFICATION.HIGHEST_HONOURS_SUMMA_CUM_LAUDE,
    label: 'Highest Honours Summa Cum Laude',
  },
  {
    value: AWARD_CLASSIFICATION.FIRST_CLASS_HONOURS,
    label: 'First Class Honours',
  },
  {
    value: AWARD_CLASSIFICATION.HIGH_HONOURS_MAGNA_CUM_LAUDE,
    label: 'High Honours Magna Cum Laude',
  },
  {
    value: AWARD_CLASSIFICATION.SECOND_UPPER_DIVISION_I_CLASS_HONOURS,
    label: 'Second Upper Division I Class Honours',
  },
  {
    value: AWARD_CLASSIFICATION.SECOND_UPPER_DIVISION_II_CLASS_HONOURS,
    label: 'Second Lower Division II Class Honours',
  },
  {
    value: AWARD_CLASSIFICATION.THIRD_CLASS_HONOURS,
    label: 'Third Class Honours',
  },
  {
    value: AWARD_CLASSIFICATION.HONOURS_CUM_LAUDE,
    label: 'Honours Cum Laude',
  },
  {
    value: AWARD_CLASSIFICATION.DISTINCTION,
    label: 'Distinction',
  },
  {
    value: AWARD_CLASSIFICATION.CREDIT,
    label: 'Credit',
  },
  {
    value: AWARD_CLASSIFICATION.PASS,
    label: 'Pass',
  },
  {
    value: AWARD_CLASSIFICATION.MERIT,
    label: 'Merit',
  },
];

const GPATypeText =
  PAGE_TEXT.QUALIFICATION.ACADEMIC_QUALIFICATION.GPA_DIALOG.GPA_TYPE_OPTIONS;

export const GPATypeOptions: SelectOption[] = Object.values(GPATypeText).map(
  (label: string) => ({
    value: label,
    label,
  }),
);
